import { MBIconV2Name } from '@shared/components/image';
import { API } from '@shared/types/api';
import { GenericComponent } from '../../config';
import { FieldOption } from './FieldOption';

export class BasicFieldOption implements FieldOption {
  constructor(
    readonly title: string,
    readonly icon: MBIconV2Name,
    readonly component: Partial<GenericComponent>,
  ) {}

  matchesComponent(component: API.AnyComponent, reservedIds: Array<string>): boolean {
    const isReserved = !!reservedIds.find(id => id === component.id);
    return !isReserved && this.component.type === component.type;
  }

  canBeAdded(_components: API.AnyComponent[]): boolean {
    return true;
  }
}
